window.addEventListener("trix-file-accept", function(event) {
  const acceptedTypes = ['image/svg+xml']
  if (acceptedTypes.includes(event.file.type)) {
    event.preventDefault()
    alert("SVG attachment is not supported")
  }
})